import { render, staticRenderFns } from "./DicasUpload.vue?vue&type=template&id=30f724d9&scoped=true"
import script from "./DicasUpload.vue?vue&type=script&lang=js"
export * from "./DicasUpload.vue?vue&type=script&lang=js"
import style0 from "./DicasUpload.vue?vue&type=style&index=0&id=30f724d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f724d9",
  null
  
)

export default component.exports